/* eslint-disable camelcase, @typescript-eslint/naming-convention */
// New-conversation nudge ack (ipa-training-mode).
// Cross-repo Nudge Contract v1 — POST the user's accept/dismiss choice back to
// the orchestrator. Fail-open: the banner UX (starting a new conversation /
// hiding the banner) always completes locally regardless of ack outcome; a
// failed ack POST is swallowed here so it never surfaces to the user.
import orchestratorApiClient from './orchestrator-api-client';
import { NUDGE_ACK_PATH } from '../constants/nudge';
export function ackNudge(payload) {
    void orchestratorApiClient.post(NUDGE_ACK_PATH, payload).catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('[AIChatWidget] Nudge ack failed to send; continuing (fail-open):', err);
        }
    });
}
